import React, { Component } from 'react';

import DotLine from '../DotLine';
import CourseDetail from './CourseDetail/CourseDetail';
import PriceDetail from './PriceDetail/PriceDetail';
import tvIcon from '../../assets/image/icon_tv.svg';
import internetIcon from '../../assets/image/icon_internet.svg';
import phoneIcon from '../../assets/image/icon_phone.svg';

class PlanDetail extends Component {
  render() {
    const { plan } =  this.props;
    const {
      set,
      // plan,
      tvCourse,
      tvCourseWeight,
      tvPrice,
      tvPriceWithTax,
      fourK,
      internetCourse,
      internetCourseWeight,
      internetPrice,
      internetPriceWithTax,
      phoneCourse,
      phoneCourseWeight,
      phonePrice,
      phonePriceWithTax,
      discountValue,
      discountValueWithTax,
      totalPrice,
      totalPriceWithTax,
      discountPrice,
      discountPriceWithTax,
      smartValue,
      homeDicount,
    } =  plan;

    const tv = tvCourseWeight ? (
      <React.Fragment>
        <div className="PlanDetailRow" >
          <img src={tvIcon} className="PlanDetailIcon" alt="tvIcon" />
          <CourseDetail
            name={tvCourse}
            price={tvPrice}
            priceWithTax={tvPriceWithTax}
          />
        </div>
        <DotLine PlanCard />
      </React.Fragment>
    ) : null;

    const internet = internetCourseWeight ? (
      <React.Fragment>
        <div className="PlanDetailRow" >
          <img src={internetIcon} className="PlanDetailIcon" alt="internetIcon" />
          <CourseDetail
            name={internetCourse}
            price={internetPrice}
            priceWithTax={internetPriceWithTax}
          />
        </div>
        <DotLine PlanCard />
      </React.Fragment>
    ) : null;

    const phone = phoneCourseWeight ? (
      <React.Fragment>
        <div className="PlanDetailRow" >
          <img src={phoneIcon} className="PlanDetailIcon" alt="phoneIcon" />
          <CourseDetail
            name={`でんわ (${phoneCourse})`}
            price={phonePrice}
            priceWithTax={phonePriceWithTax}
          />
        </div>
        <DotLine PlanCard />
      </React.Fragment>
    ) : null;

    return (
      <div className="PlanDetail">
        <div className="PlanDetailTitle">
          <div className="PlanDetailTitleText">
            プラン詳細
          </div>
          <div className="PlanDetailSetText">
            {set}
          </div>
        </div>
        <div className="PlanDetailItem">
          {tv}
          {internet}
          {phone}
          <PriceDetail
            naturalPrice={totalPrice}
            naturalPriceWithTax={totalPriceWithTax}
            discountValue={discountValue}
            discountValueWithTax={discountValueWithTax}
            discountPrice={discountPrice}
            discountPriceWithTax={discountPriceWithTax}
            smartValue={smartValue}            
            fourK={fourK}
            homeDicount={homeDicount}
          />
        </div>
      </div>
    );
  };
};

export default PlanDetail;
